import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Observable, throwError, BehaviorSubject } from 'rxjs';
//import { catchError, retry } from 'rxjs/operators';
import { APIResponse, Employee, EmployeeRole, Group, SearchEmployeeGroupRole } from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class EmployeeService {
    public currentEmployee: Employee = {} as Employee;
    public employeeRoles: SearchEmployeeGroupRole[] = [];

    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    public getAllEmployees() {
        return this.http.get<Employee[]>(this.baseUrl + 'api/Employee/GetAllEmployees');
    }

    public getActiveEmployees() {
        return this.http.get<Employee[]>(this.baseUrl + 'api/Employee/GetActiveEmployees');
    }

    public getAllEmployeeGroups() {
        return this.http.get<Group[]>(this.baseUrl + 'api/Employee/GetAllEmployeeGroups');
    }

    public getEmployeeGroupByID(groupID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetEmployeeGroupByID/?groupID=' + groupID);
    }

    public getAllBranches() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Branch/GetAllBranches');
    }

    public getDepartments() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Department/GetDepartments');
    }

    public saveEmployee(employee: Employee) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Employee/SaveEmployee', employee, httpOptions);
    }

    public saveGroup(group: Group) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Employee/SaveGroup', group, httpOptions);
    }

    public saveEmployeeGroupMap(groupID: number, employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/SaveEmployeeGroupMap/?groupID=' + groupID + '&employeeID=' + employeeID);
    }

    public deleteEmployeeGroupMap(employeeGroupMapID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/DeleteEmployeeGroupMap/?employeeGroupMapID=' + employeeGroupMapID);
    }

    public getSearchEmployeeGroups() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeGroups');
    }

    public getSearchEmployeeGroupByEmployeeID(employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeGroupByEmployeeID/?employeeID=' + employeeID);
    }

    public getSearchEmployeeGroupByGroupID(groupID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeGroupByGroupID/?groupID=' + groupID);
    }

    public getSearchEmployeeGroupRoles() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeGroupRoles');
    }

    public getSearchEmployeeGroupRolesByEmployeeRoleName(employeeRoleName: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeGroupRolesByEmployeeRoleName/?employeeRoleName=' + employeeRoleName);
    }

    public getSearchEmployeeGroupRoleMaps() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeGroupRoleMaps');
    }

    public getSearchEmployeeGroupRoleMapsByEmployeeRoleID(employeeRoleID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeGroupRoleMapsByEmployeeRoleID/?employeeRoleID=' + employeeRoleID);
    }

    public getSearchEmployeeGroupRoleMapsByEmployeeRoleName(employeeRoleName: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeGroupRoleMapsByEmployeeRoleName/?employeeRoleName=' + employeeRoleName);
    }

    public saveEmployeeGroupRoleMap(employeeRoleID: number, groupID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/SaveEmployeeGroupRoleMap/?employeeRoleID=' + employeeRoleID + '&groupID=' + groupID);
    }

    public deleteEmployeeGroupRoleMap(employeeGroupRoleMapID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/DeleteEmployeeGroupRoleMap/?employeeGroupRoleMapID=' + employeeGroupRoleMapID);
    }

    public getEmployeesByGroupName(groupName: string) {
        return this.http.get<Employee[]>(this.baseUrl + 'api/Employee/GetEmployeesByGroupName/?groupName=' + groupName);
    }

    public getSearchEmployeeCustomerTeamByEmployeeID(employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeCustomerTeamByEmployeeID/?employeeID=' + employeeID);
    }

    public getSearchEmployeeCustomerTeamByCustomerTeamTypeAbbreviation(customerTeamTypeAbbreviation: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeCustomerTeamByCustomerTeamTypeAbbreviation/?customerTeamTypeAbbreviation=' + customerTeamTypeAbbreviation);
    }

    public GetSearchEmployeeCustomerTeamByCustomerTeamTypeDescription(customerTeamTypeDescription: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetSearchEmployeeCustomerTeamByCustomerTeamTypeDescription/?customerTeamTypeDescription=' + customerTeamTypeDescription);
    }

    public getEmployeeById(id: number) {
        return this.http.get<Employee>(this.baseUrl + 'api/Employee/GetEmployeeById/?id=' + id);
    }

    public getEmployeesERPAssignedTo() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/CarrierRepsAssigned/GetAllEmployeeERPAssignedTo/');
    }

    public getEmployeeRoles() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Employee/GetEmployeeRoles/');
    }

    public getSearchEmployeeGroupRolesByEmployeeID(id: number) {
        return this.http.get<SearchEmployeeGroupRole[]>(this.baseUrl + 'api/Employee/GetSearchEmployeeGroupRolesByEmployeeID/?id=' + id);
    }

    public getLoggedInEmployee() {
        var id = parseInt(localStorage.getItem('EmployeeId')!);
        return this.http.get<Employee>(this.baseUrl + 'api/Employee/GetEmployeeById/?id=' + id);
    }
}
